import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CreateCargoComponent } from './create-cargo.component';
import { MaterialModule } from 'src/app/shared/material/material.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';



@NgModule({
  declarations: [
    CreateCargoComponent
  ],
  imports: [
    CommonModule,
    MaterialModule,
    ReactiveFormsModule,
    FormsModule

  ],
  exports:[
    CreateCargoComponent
  ]
})
export class CreateCargoModule { }
